import { IDanceClass } from "../models";

export const isAgeValidForClass = (classDetails: IDanceClass, age: number) => {
  if (!classDetails.minAge && classDetails.maxAge && age <= classDetails.maxAge) {
    return true;
  } else if (!classDetails.maxAge && classDetails.minAge && age >= classDetails.minAge) {
    return true;
  } else if (classDetails.minAge && classDetails.maxAge && age >= classDetails.minAge && age <= classDetails.maxAge) {
    return true;
  }
  return false;
}